/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Leo Khramov
 */

// Imports

import React from "react"
import {
    Modal,
    TitleSection,
    Label,
    ContentSection,
    FooterSection,
    Button,
    Icon,
    Row,
    Column,
    Element,
    Stack,
    Color,
    trackEvent,
} from "trux"
import "./EnjoyingMomentDialog.css"
import { useSelector } from "react-redux"
import { useHistory } from "react-router"
import traceMomentImg from "../../assets/img/trace_moment.jpg"

export const ABTEST_ENJOY_MOMENT_EVERY_N_TIMES = 5

export const EnjoyingMomentDialog = () => {
    const event = useSelector((state) => state.video.value.source)
    const history = useHistory()

    const handleKeepWatching = (e) => {
        trackEvent({
            action: "Keep Watching Pressed",
            element: e.currentTarget,
        })
        event.backJumpTimes = 0
        history.replace(".")
        document.dispatchEvent(new CustomEvent("trc-next"))
    }

    const handleSaveMoment = (e) => {
        trackEvent({
            action: "Save to Trace iD Pressed",
            element: e.currentTarget,
        })
        event.backJumpTimes = 0
        history.push("./save/profile")
    }

    if (!event) return null

    document.dispatchEvent(new CustomEvent("trc-pause"))

    return (
        <Modal
            trkContext={`A/B: B EnjoyingMoment`}
            className="enjoy-moment"
            open={true}
            onShadeClick={handleKeepWatching}
        >
            <TitleSection className="header" onCloseClick={handleKeepWatching}>
                <Label
                    className="title"
                    type={Label.Type.Heading4}
                    content="Enjoying this moment?"
                />
            </TitleSection>
            <ContentSection>
                <Column alignItems="center">
                    <Stack
                        className="image-stack"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Element className="place-holder" />
                        <Element
                            tag="img"
                            className="back-moment-image"
                            src={traceMomentImg}
                        />
                        <Icon
                            type={Icon.Type.TraceIDFilled}
                            size={80}
                            color={Color.White2}
                        />
                    </Stack>
                    <Label
                        type={Label.Type.Body}
                        bold
                        content="Save it to your Trace iD!"
                        margin="3"
                    />
                    <Label
                        center
                        type={Label.Type.Body}
                        marginLeft="4"
                        marginRight="4"
                        content="Trace iD is the home for all your soccer highlights."
                    />
                    <Label center type={Label.Type.Body}>
                        <Element
                            tag="a"
                            href="https://traceup.com/soccer/trace-id"
                        >
                            Learn more about Trace iD.
                        </Element>
                    </Label>
                </Column>
            </ContentSection>
            <FooterSection>
                <Button
                    primary
                    content={
                        <Row alignItems="center">
                            <Icon type={Icon.Type.TraceIDEmpty} />
                            <Label content="Save this moment" marginLeft="2" />
                        </Row>
                    }
                    onClick={handleSaveMoment}
                />
                <Button
                    content={"Keep watching"}
                    onClick={handleKeepWatching}
                />
            </FooterSection>
        </Modal>
    )
}
